module.exports = "/assets/fe5a66ec1b4aaef7ff484f2b482494f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/VS.png
// module id = 3056
// module chunks = 0